import React from 'react';
import { Vector3 } from 'three';
import { Canvas, CanvasProps } from '@react-three/fiber';
import { Grid, GridProps } from '../Grid';
import { OrbitControls } from '@react-three/drei';

type Props = React.PropsWithChildren<
  CanvasProps & {
    cameraFov?: number;
    cameraPosition?: Vector3;
    controls?: boolean;
    lights?: boolean;
    grid?: boolean | GridProps;
  }
>;

export const Setup = ({
  children,
  cameraFov = 75,
  cameraPosition = new Vector3(-5, 5, 5),
  controls = true,
  lights = true,
  grid = false,
  ...restProps
}: Props) => (
  <Canvas
    shadows
    camera={{ position: cameraPosition, fov: cameraFov }}
    {...restProps}
    style={{
      width: '100vw',
      height: '100vh',
    }}
  >
    {children}
    {lights && (
      <>
        <ambientLight intensity={0.8 * Math.PI} />
        <pointLight intensity={1 * Math.PI} position={[0, 6, 0]} decay={0} />
      </>
    )}
    {controls && <OrbitControls makeDefault />}
    {grid && <Grid {...(typeof grid === 'boolean' ? null : grid)} />}
  </Canvas>
);
